import { Link } from 'react-router-dom';
import { Heart, Gift } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="border-t bg-muted/30 mt-auto relative backdrop-blur-sm">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <Gift className="w-7 h-7 text-primary" />
              <span className="text-xl font-bold">Budgetter</span>
            </div>
            
            {/* Über Budgetter Absatz */}
            <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
              <strong>Seit 2024</strong> hilft Budgetter Menschen, mit künstlicher 
              Intelligenz das perfekte Geschenk zu finden – kostenlos und datenschutzfreundlich.
            </p>
            
            <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
              Der intelligenteste Geschenkfinder der Welt. Finde das perfekte 
              Geschenk in unter 2 Minuten mit KI-Power.
            </p>
            
            <Link 
              to="/questionnaire"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg 
                         bg-primary/10 text-primary hover:bg-primary/20 transition-all 
                         hover:shadow-[0_0_20px_hsl(var(--primary)/0.3)] text-sm font-medium"
            >
              <Heart className="w-4 h-4" />
              Geschenk finden
            </Link>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-semibold text-base mb-6">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-muted-foreground hover:text-primary 
                                        transition-all hover:translate-x-1 inline-block 
                                        py-2 px-3 min-h-[44px] rounded">
                  Startseite
                </Link>
              </li>
              <li>
                <Link to="/magazin" className="text-sm text-muted-foreground 
                                               hover:text-primary transition-all 
                                               hover:translate-x-1 inline-block 
                                               py-2 px-3 min-h-[44px] rounded">
                  Magazin
                </Link>
              </li>
              <li>
                <Link to="/ueber-uns" className="text-sm text-muted-foreground 
                                                 hover:text-primary transition-all 
                                                 hover:translate-x-1 inline-block 
                                                 py-2 px-3 min-h-[44px] rounded">
                  Über uns
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-sm text-muted-foreground 
                                               hover:text-primary transition-all 
                                               hover:translate-x-1 inline-block 
                                               py-2 px-3 min-h-[44px] rounded">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Rechtliches */}
          <div>
            <h3 className="font-semibold text-base mb-6">Rechtliches</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/impressum" className="text-sm text-muted-foreground 
                                                 hover:text-primary transition-all 
                                                 hover:translate-x-1 inline-block 
                                                 py-2 px-3 min-h-[44px] rounded">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="text-sm text-muted-foreground 
                                                   hover:text-primary transition-all 
                                                   hover:translate-x-1 inline-block 
                                                   py-2 px-3 min-h-[44px] rounded">
                  Datenschutzerklärung
                </Link>
              </li>
              <li>
                <a 
                  href="/sitemap.xml"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-muted-foreground hover:text-primary 
                             transition-all hover:translate-x-1 inline-block 
                             py-2 px-3 min-h-[44px] rounded"
                >
                  Sitemap
                </a>
              </li>
              <li>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    try {
                      if ((window as any).fc && (window as any).fc.showDialog) {
                        (window as any).fc.showDialog();
                      } else {
                        alert('Cookie-Einstellungen werden geladen. Bitte versuchen Sie es gleich erneut.');
                      }
                    } catch (error) {
                      console.error('Error opening CMP dialog:', error);
                    }
                  }}
                  className="text-sm text-muted-foreground hover:text-primary 
                             transition-all hover:translate-x-1 inline-block 
                             py-2 px-3 min-h-[44px] rounded text-left"
                >
                  Cookie-Einstellungen
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Editorial Trust Signal */}
        <div className="border-t pt-8 pb-6">
          <div className="bg-primary/5 p-6 rounded-xl">
            <h3 className="font-semibold text-base mb-4 flex items-center gap-2">
              <span className="text-xl" role="img" aria-label="Redaktion">✍️</span>
              Über unsere Redaktion
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Unsere Autor:innen recherchieren aktuelle Geschenktrends und prüfen 
              Empfehlungen mit KI-Unterstützung. Budgetter veröffentlicht nur geprüfte, 
              redaktionell unabhängige Inhalte. Alle Produktempfehlungen basieren auf 
              objektiven Kriterien wie Nutzerbewertungen, Preis-Leistung und 
              Qualitätsmerkmalen – nicht auf Provisionen.
            </p>
          </div>
        </div>

        {/* Affiliate Disclaimer */}
        <div className="border-t pt-8 pb-6">
          <div className="bg-muted/50 p-4 rounded-lg mb-6">
            <p className="text-xs text-muted-foreground text-center leading-relaxed">
              <strong>Affiliate-Hinweis:</strong> Als Amazon-Partner verdienen wir 
              an qualifizierten Käufen. Preise und Verfügbarkeit können variieren. 
              Die mit * gekennzeichneten Links sind Affiliate-Links. Unsere redaktionellen 
              Empfehlungen sind unabhängig und werden nicht durch Provisionen beeinflusst.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t pt-8 flex flex-col md:flex-row justify-between 
                        items-center gap-6">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Budgetter. Alle Rechte vorbehalten.
          </p>
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-3">
            <Link to="/" className="text-sm text-muted-foreground hover:text-primary 
                                   transition-all hover:translate-y-[-2px]">
              Startseite
            </Link>
            <Link to="/questionnaire" className="text-sm text-muted-foreground 
                                                 hover:text-primary transition-all 
                                                 hover:translate-y-[-2px]">
              Geschenk finden
            </Link>
            <Link to="/magazin" className="text-sm text-muted-foreground 
                                           hover:text-primary transition-all 
                                           hover:translate-y-[-2px]">
              Magazin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
